import {
  BusinessValueSection,
  ClosedLoopSection,
  ComplianceSection,
  HeroSection,
  IntroductionSection,
  ProblemSection,
  RolloutSection,
  SensorCoverageSection,
  SystemLayersSection,
} from '../components/homepage';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../components/homepage/Footer';

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.slice(1);
    if (!id) return;

    const node = document.getElementById(id);
    if (!node) return;

    node.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [location.hash]);

  return (
    <main className="min-h-screen bg-slate-100 font-sans">
      <HeroSection />
      <IntroductionSection />
      <ProblemSection />
      <SystemLayersSection />
      <SensorCoverageSection />
      <ClosedLoopSection />
      <BusinessValueSection />
      <ComplianceSection />
      <RolloutSection />
      <Footer />
    </main>
  );
}

export default HomePage;
